import {
  ChartLineIcon,
  ChatCenteredDotsIcon,
  FileTextIcon,
  VideoIcon,
} from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

export const FlashProjectProperties = () => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  const flashProjectProperties = t(
    "projects.components.ProjectCreationPage.flashCardsProperties",
    { returnObjects: true }
  ) as unknown as Record<string, string>;

  const flashProjectPropertyIcons = {
    videoWalkthrough: <VideoIcon size={20} />,
    smartDocumentAnimation: <FileTextIcon size={20} />,
    aiQa: <ChatCenteredDotsIcon size={20} />,
    engagementTracking: <ChartLineIcon size={20} />,
  };

  return (
    <Flex vertical gap={8} style={{ marginTop: 24 }}>
      {Object.entries(flashProjectProperties).map(([key, value]) => (
        <Flex
          key={key}
          align="center"
          gap={8}
          style={{
            textAlign: "left",
            color: theme.colorTextSecondary,
          }}
        >
          <div style={{ width: 20, height: 20 }}>
            {flashProjectPropertyIcons[key]}
          </div>
          <Typography.Text style={{ fontSize: 12 }} type="secondary">
            {value}
          </Typography.Text>
        </Flex>
      ))}
    </Flex>
  );
};
